import { getFunctions as _getFunctions } from '@firebase/functions';
import { getApp } from './getApp.ts';

export const getFunctions = () => _getFunctions(getApp(), process.env.PUBLIC_FB_FUNCTIONS_REGION);
